import { render } from "./IconWarehouse.vue?vue&type=template&id=94f0693e"
import script from "./IconWarehouse.vue?vue&type=script&lang=ts"
export * from "./IconWarehouse.vue?vue&type=script&lang=ts"
script.render = render

export default script